import React from "react";
import "./Navibar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { Navbar, Container, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Navibar = () => {
  const navigate = useNavigate();

  return (
    <Navbar variant="dark" className="navibar">
      <Container>
        <Navbar.Brand href="/Personnel" >
          {" "}
          <img src="/schedule.png" alt="Pass Icon" width="28" height="28" /> ATTENDANCE SYSTEM
          {/* <FontAwesomeIcon icon={faUsers} />  */}
          {/* <FontAwesomeIcon icon={faUsers} /> ATTENDANCE SYSTEM */}
        </Navbar.Brand>
      </Container>
      {/* <Stack direction="horizontal" className="username">
        <div>Username</div>
      </Stack> */}
    </Navbar>
  );
};

export default Navibar;
